module.exports = __webpack_public_path__ + "img/hx-kfapi.0194228a.svg";